// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 결재 패널(dap-panel) 아래에 붙일 때 sticky 중복 방지 */
.dlm-under-approval {
  margin-top: 14px;
  position: static;
  top: auto;
}

.dlm-window-range {
  font-weight: 700;
  color: var(--mrt-text-2, #57534e);
}

.dlm-legend {
  display: inline;
  font-weight: 600;
  color: var(--mrt-muted, #78716c);
}

.dlm-legend__today {
  display: inline-block;
  margin: 0 1px;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 800;
  font-size: 10px;
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}

.dlm-legend__tomorrow {
  display: inline-block;
  margin: 0 1px;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 800;
  font-size: 10px;
  background: #dbeafe;
  color: #1e40af;
  border: 1px solid #93c5fd;
}

/* dap-list와 동일 max-height 톤 — 한 줄 행 */
.dlm-line-list {
  gap: 0 !important;
  max-height: min(50vh, 420px);
}

.dlm-line-item {
  list-style: none;
  margin: 0;
  padding: 10px 10px 10px 10px;
  border-bottom: 1px solid var(--mrt-border, #e8e6e3);
  font-size: 12px;
  font-weight: 650;
  color: var(--mrt-text, #1c1917);
  line-height: 1.35;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  border-left: 3px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.dlm-line-item--off-today {
  background: linear-gradient(105deg, #ecfdf5 0%, #f0fdf4 18%, rgba(240, 253, 244, 0.35) 42%, transparent 72%);
  border-left-color: #16a34a;
  box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.12);
}

.dlm-line-item--off-tomorrow {
  background: linear-gradient(105deg, #eff6ff 0%, #f0f9ff 20%, rgba(240, 249, 255, 0.4) 45%, transparent 75%);
  border-left-color: #2563eb;
  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.12);
}

.dlm-chip {
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.04em;
  padding: 3px 7px;
  border-radius: 5px;
  line-height: 1;
}

.dlm-chip--today {
  background: #16a34a;
  color: #fff;
  box-shadow: 0 1px 2px rgba(22, 163, 74, 0.35);
}

.dlm-chip--tomorrow {
  background: #2563eb;
  color: #fff;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.35);
}

.dlm-line-list .dlm-line-item:last-child {
  border-bottom: none;
}

.dlm-line-name {
  font-weight: 800;
  color: #0c4a6e;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dlm-line-item--off-today .dlm-line-name {
  color: #14532d;
}

.dlm-line-item--off-tomorrow .dlm-line-name {
  color: #1e3a8a;
}

.dlm-type-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 2px 9px 2px 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  border: 1px solid transparent;
  white-space: nowrap;
}

.dlm-type-pill__emoji {
  font-size: 13px;
  line-height: 1;
}

.dlm-type-pill--annual {
  background: #e0f2fe;
  color: #075985;
  border-color: #7dd3fc;
}

.dlm-type-pill--half {
  background: #fef9c3;
  color: #854d0e;
  border-color: #fde047;
}

.dlm-type-pill--sick {
  background: #fce7f3;
  color: #9d174d;
  border-color: #f9a8d4;
}

.dlm-type-pill--special {
  background: #f0fdf4;
  color: #166534;
  border-color: #86efac;
}

.dlm-type-pill--public {
  background: #f5f3ff;
  color: #5b21b6;
  border-color: #c4b5fd;
}

.dlm-type-pill--default {
  background: #f1f5f9;
  color: #475569;
  border-color: #cbd5e1;
}

.dlm-line-period {
  font-weight: 700;
  color: #44403c;
  white-space: nowrap;
}

.dlm-line-days {
  font-weight: 800;
  color: #57534e;
  white-space: nowrap;
}

.dlm-line-sep {
  color: #a8a29e;
  font-weight: 700;
  padding: 0 1px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardLeaveMonthPanel.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,4BAA4B;EAC5B,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,0DAA0D;AAC5D;;AAEA;EACE,4GAA4G;EAC5G,0BAA0B;EAC1B,mDAAmD;AACrD;;AAEA;EACE,2GAA2G;EAC3G,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* 결재 패널(dap-panel) 아래에 붙일 때 sticky 중복 방지 */\n.dlm-under-approval {\n  margin-top: 14px;\n  position: static;\n  top: auto;\n}\n\n.dlm-window-range {\n  font-weight: 700;\n  color: var(--mrt-text-2, #57534e);\n}\n\n.dlm-legend {\n  display: inline;\n  font-weight: 600;\n  color: var(--mrt-muted, #78716c);\n}\n\n.dlm-legend__today {\n  display: inline-block;\n  margin: 0 1px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-weight: 800;\n  font-size: 10px;\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n\n.dlm-legend__tomorrow {\n  display: inline-block;\n  margin: 0 1px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-weight: 800;\n  font-size: 10px;\n  background: #dbeafe;\n  color: #1e40af;\n  border: 1px solid #93c5fd;\n}\n\n/* dap-list와 동일 max-height 톤 — 한 줄 행 */\n.dlm-line-list {\n  gap: 0 !important;\n  max-height: min(50vh, 420px);\n}\n\n.dlm-line-item {\n  list-style: none;\n  margin: 0;\n  padding: 10px 10px 10px 10px;\n  border-bottom: 1px solid var(--mrt-border, #e8e6e3);\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--mrt-text, #1c1917);\n  line-height: 1.35;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 6px;\n  border-left: 3px solid transparent;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.dlm-line-item--off-today {\n  background: linear-gradient(105deg, #ecfdf5 0%, #f0fdf4 18%, rgba(240, 253, 244, 0.35) 42%, transparent 72%);\n  border-left-color: #16a34a;\n  box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.12);\n}\n\n.dlm-line-item--off-tomorrow {\n  background: linear-gradient(105deg, #eff6ff 0%, #f0f9ff 20%, rgba(240, 249, 255, 0.4) 45%, transparent 75%);\n  border-left-color: #2563eb;\n  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.12);\n}\n\n.dlm-chip {\n  flex-shrink: 0;\n  font-size: 9px;\n  font-weight: 900;\n  letter-spacing: 0.04em;\n  padding: 3px 7px;\n  border-radius: 5px;\n  line-height: 1;\n}\n\n.dlm-chip--today {\n  background: #16a34a;\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(22, 163, 74, 0.35);\n}\n\n.dlm-chip--tomorrow {\n  background: #2563eb;\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.35);\n}\n\n.dlm-line-list .dlm-line-item:last-child {\n  border-bottom: none;\n}\n\n.dlm-line-name {\n  font-weight: 800;\n  color: #0c4a6e;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dlm-line-item--off-today .dlm-line-name {\n  color: #14532d;\n}\n\n.dlm-line-item--off-tomorrow .dlm-line-name {\n  color: #1e3a8a;\n}\n\n.dlm-type-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  padding: 2px 9px 2px 6px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.dlm-type-pill__emoji {\n  font-size: 13px;\n  line-height: 1;\n}\n\n.dlm-type-pill--annual {\n  background: #e0f2fe;\n  color: #075985;\n  border-color: #7dd3fc;\n}\n\n.dlm-type-pill--half {\n  background: #fef9c3;\n  color: #854d0e;\n  border-color: #fde047;\n}\n\n.dlm-type-pill--sick {\n  background: #fce7f3;\n  color: #9d174d;\n  border-color: #f9a8d4;\n}\n\n.dlm-type-pill--special {\n  background: #f0fdf4;\n  color: #166534;\n  border-color: #86efac;\n}\n\n.dlm-type-pill--public {\n  background: #f5f3ff;\n  color: #5b21b6;\n  border-color: #c4b5fd;\n}\n\n.dlm-type-pill--default {\n  background: #f1f5f9;\n  color: #475569;\n  border-color: #cbd5e1;\n}\n\n.dlm-line-period {\n  font-weight: 700;\n  color: #44403c;\n  white-space: nowrap;\n}\n\n.dlm-line-days {\n  font-weight: 800;\n  color: #57534e;\n  white-space: nowrap;\n}\n\n.dlm-line-sep {\n  color: #a8a29e;\n  font-weight: 700;\n  padding: 0 1px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
